export const categories = [
  { slug: "all", name: "全部", icon: "ri-apps-line" },
  { slug: "romance", name: "爱情", icon: "ri-heart-line" },
  { slug: "fantasy", name: "奇幻", icon: "ri-magic-line" },
  { slug: "action", name: "动作", icon: "ri-flashlight-line" },
  { slug: "thriller", name: "悬疑", icon: "ri-search-eye-line" },
  { slug: "comedy", name: "搞笑", icon: "ri-emotion-laugh-line" },
  { slug: "drama", name: "剧情", icon: "ri-film-line" },
  { slug: "horror", name: "恐怖", icon: "ri-ghost-line" },
  { slug: "daily", name: "日常", icon: "ri-calendar-line" },
  { slug: "historical", name: "历史", icon: "ri-ancient-gate-line" },
];